import { some } from 'lodash';

function canAddMoreCustomPrograms({ customFields }) {
  return !some(customFields, { group: { value: '' } });
}

export default canAddMoreCustomPrograms;
